<template>
  <nuxt-link :class="$style.container" :to="`/company/cruise/${ cruise.id }`" target="_blank">
    <div :class="$style.cover">
      <el-image fit="cover" lazy :class="$style.coverImg" :src="cruise.cover">
		<div class="text-white text-center relative" slot="error">
			<img :src="IMG_PLACEHOLDER" alt="加载失败">
			<p class="absolute top-15.5 left-0 right-0 text-xxs">加载失败</p>
		</div>
	  </el-image>
      <el-image fit="contain" lazy :class="$style.logo" :src="cruise.logo" />
    </div>

    <dl :class="$style.content">
      <dt :class="$style.name" :title="cruise.name">{{ cruise.name }}</dt>
      <!-- <dt :class="$style.enName">{{ cruise.en_name }}</dt> -->
      <dd :class="$style.attrs">
        <!-- renovation_time > first_flight_time ? renovation_time : first_flight_time -->
        <span v-if="cruise.renovation_time > cruise.first_flight_time" :class="$style.attr">翻新时间 {{cruise.renovation_time}}</span>
        <span v-else :class="$style.attr">首航时间 {{ cruise.first_flight_time }}</span>
        <span v-if="cruise.passenger_capacity" :class="$style.attr">乘客 {{ cruise.passenger_capacity }}</span>
      </dd>
      <dd v-if="hasLanLat" :class="$style.tags">
        <div :class="$style.tag"><i class="ficon ficon-dingwei"></i><span class="ml-1">定位跟踪</span></div>
      </dd>
      <dd :class="$style.actions" @click.stop.prevent>
        <cruise-dialog-share class="w-1/3" :cruiseid="cruise.id" :cruiseName="cruise.name">
          <button :class="$style.action"><i :class="$style.actionIcon" class="ficon ficon-xingzhuangjiehe2" /><span
              :class="$style.actionText">分享</span></button>
        </cruise-dialog-share>
        <button class="w-1/3" :class="[$style.action, isFavorite ? $style.isActive : '']" @click="onToggleFavorite(cruise.id)"><i
            :class="[$style.actionIcon, iconClass]" /><span :class="$style.actionText">{{ isFavorite ? '已收藏' : "收藏"}}</span></button>
        <button v-if="hasLanLat" class="w-1/3" :class="[$style.action, isLocation ? $style.isActive : '']" @click="onLocation"><i :class="[$style.actionIcon, isLocation ? 'ficon-a-dangqianweizhigaoliang' : 'ficon-dangqianweizhi']" class="ficon" /><span
            :class="$style.actionText">当前位置</span></button>
      </dd>
    </dl>
  </nuxt-link>
</template>
<script>
import { computed, defineComponent, useRoute, useRouter } from "@nuxtjs/composition-api";
import useFavorite from "./composables/useFavorite";

import CruiseDialogShare from "@/views/company/CruiseDialogShare.vue";
import { isEmpty } from "lodash";
import IMG_PLACEHOLDER from '~/assets/img/cruise-map/cruise-cover-placeholder.png'
export default defineComponent({
	name: "IndexCruiseItem",
	components: {
		CruiseDialogShare
	},
	props: {
		cruise: {
			type: Object,
			default: () => ({})
		},
		actions: {
			type: Array,
			default: () => ['share', 'collection', 'location']
		}
	},
	emits: ["toggle-collection"],
	setup(props) {
		// const
		const { isFavorite, toggleFavorite, iconClass } = useFavorite();

		isFavorite.value = props.cruise.collection;
		const router = useRouter();
		const route = useRoute();
		function onLocation() {
			const { cruiseId } = route.value.query;
			if (cruiseId === props.cruise.id) {
				return;
			}
			router.replace({
				path: route.value.path,
				query: {
					...route.value.query,
					cruiseId: props.cruise.id,
				}
			});
		}

		const isLocation = computed(() => {
			return route.value.query.cruiseId === props.cruise.id
		})

		const hasLanLat = computed(() => !isEmpty(props.cruise.longitude) && !isEmpty(props.cruise.latitude))

		return {
			IMG_PLACEHOLDER,

			hasLanLat,

			isFavorite,
			iconClass,
			toggleFavorite,
			isLocation,
			// onToggleFavorite,
			onLocation
		};
	},
	methods: {
		onToggleFavorite(id) {
			if (!this.$store.getters.loggedIn) {
				const dialog = this.$createLoginDialog({
					onSuccess: async () => {
						dialog.hide();
						this.toggleFavorite(id).then(() => {
							this.$emit("toggle-collection", !this.cruise.collection);
						});
					},
					onClosed() {
						dialog.remove();
					}
				}).show();
			} else {
				this.toggleFavorite(id).then(() =>
					this.$emit("toggle-collection", !this.cruise.collection)
				);
			}
		}
	}
});
</script>
<style lang="scss" module>
.container:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}
.container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  padding-top: 1rem;
  padding-bottom: 1rem;
  position: relative;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
}
.container::before {
  content: "";
  border-top-width: 1px;
  height: 0px;
  position: absolute;
  left: 0.75rem;
  right: 0.75rem;
  bottom: 0px;
}
.cover {
  border-radius: 0.25rem;
  height: 5.625rem;
  overflow: hidden;
  position: relative;
  width: 7.25rem;
}
.coverImg {
  height: 100%;
  width: 100%;
}
.logo {
  height: 1.25rem;
  position: absolute;
  left: 0.5rem;
  top: 0.5rem;
  width: 3.75rem;
}
.content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  padding-left: 1rem;
}
.name {
  cursor: pointer;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.enName {
  font-size: 0.75rem;
  line-height: 1rem;
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
  --tw-text-opacity: 1;
  color: rgba(96, 99, 112, var(--tw-text-opacity));
}
.attrs {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  font-size: 0.75rem;
  line-height: 1rem;
  margin-top: 0.125rem;
}
.attr:last-child {
  border-style: none;
}
.attr {
  border-right-width: 1px;
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  white-space: nowrap;
}
.attr:first-child {
  padding-left: 0px;
}
.tags {
  margin-top: 0.375rem;
}
.tag {
  --tw-bg-opacity: 1;
  background-color: rgba(235, 241, 250, var(--tw-bg-opacity));
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  font-size: 0.75rem;
  line-height: 1rem;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  --tw-text-opacity: 1;
  color: rgba(135, 153, 179, var(--tw-text-opacity));
}
.actions {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  font-size: 0.75rem;
  line-height: 1rem;
  margin-top: auto;
  padding-top: 0.5rem;
}
.action {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  white-space: nowrap;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
}
.action.isActive .actionText, .action.isActive .actionIcon, .action:hover .actionText, .action:hover .actionIcon {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.actionText {
  margin-left: 0.25rem;
}
.actionIcon {
  font-size: 1rem;
  line-height: 1.5rem;
  line-height: 1;
  --tw-text-opacity: 1;
  color: rgba(148, 148, 155, var(--tw-text-opacity));
}
</style>
